import _ from "lodash";

export const selectFirmsList = state =>
  _.values(_.get(state, "firms.data", {}));

export const selectFirmsTotal = state => _.get(state, 'firms.totalFirms', 0);

export const selectFirmsPageDetails = state =>
  _.get(state, 'firms.firmsPageDetails', {});

export const selectFirmsOptions = state =>
  _.map(_.values(_.get(state, "firms.data", {})), firmObject => ({
    value: firmObject.extrn_company_id,
    label: firmObject.extrn_company_name,
  }));

export const isRequestInprogress = state => _.get(state, 'firms.request.loading', false);